import { MessageBar, MessageBarType } from "@fluentui/react";
import React from "react";
import { Link } from "react-router-dom";
import { AppRoute } from "../AppRoutes";
import { isMissingAccountEmail } from "../helpers/AccountEmailHelper";

export const AccountEmailWarning = ({
  email,
  emailConfirmed,
}: {
  email?: string;
  emailConfirmed?: boolean;
}) => {
  const missingEmail = isMissingAccountEmail(email);
  if (!missingEmail && emailConfirmed) return null;

  return (
    <MessageBar messageBarType={MessageBarType.warning}>
      {missingEmail
        ? "Email nije postavljen. Upišite i potvrdite vlastiti email kako biste mogli obnoviti zaboravljenu lozinku. "
        : "Email nije potvrđen. Potvrdite ga kako biste mogli obnoviti zaboravljenu lozinku. "}
      <Link to={AppRoute.SETTINGS_PROFILE}>Otvori postavke profila</Link>
    </MessageBar>
  );
};
